var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-page"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row flex-center-xy"},[_c('div',{staticClass:"col-12 col-content"},[_c('h1',[_vm._v("¡Error!")]),_vm._v(" "),_c('h4',[_vm._v("Page not found")])])])])])
}]

export { render, staticRenderFns }